
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'

@Component
export default class SimpleError extends Vue {
  @Prop({ type: String, default: 'generic' })
  private readonly error!: string

  @Prop({ type: String, default: 'Page not found' })
  private readonly notFoundTitle!: string

  @Prop({ type: String, default: 'The page you are looking for cannot be found.' })
  private readonly notFoundMessage!: string

  @Prop({ type: String, default: 'You are not authorised to view this page.' })
  private readonly unauthorisedMessage!: string

  @Prop({ type: String, default: 'Something went wrong finding this page.' })
  private readonly genericMessage!: string
}
